var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-simple-suggest",
    {
      attrs: { list: _vm.getSuggestions, "filter-by-query": true },
      on: { select: _vm.addTag },
    },
    [
      _c("taggle-tags", {
        attrs: { tags: _vm.currentTags, "new-tags": _vm.newTags },
        on: { "tag-update": _vm.updateTags },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }